import { FormControlLabel, FormHelperText, Stack, Switch } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

interface ToggleGroupProps {
  name: string;
  control: Control;
  defaultValue?: string[];
  disabled?: boolean;
  options: { value: string; label: string; helperText?: string }[];
}

export const HookFormToggleGroup = ({
  name,
  control,
  defaultValue,
  options,
  disabled,
}: ToggleGroupProps) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field: { value = [], onChange } }) => (
      <Stack>
        {options.map((option) => (
          <Stack key={option.value}>
            <FormControlLabel
              control={
                <Switch
                  checked={value.includes(option.value)}
                  onChange={(e) =>
                    onChange(
                      e.target.checked
                        ? [...value, option.value]
                        : value.filter((v: string) => v !== option.value)
                    )
                  }
                  disabled={disabled}
                  name={option.value}
                />
              }
              label={option.label}
            />
            {option.helperText && (
              <FormHelperText>{option.helperText}</FormHelperText>
            )}
          </Stack>
        ))}
      </Stack>
    )}
  />
);
